import './index.less'
import React from 'react';
const QueryRecordCard = (props) => {
  const { data, type } = props

  const queryRecord = (item) => {
    props.queryRecord(item)
  }
  return (
    <div>
      {data &&
        data.map((item, index) => {
          return (
            <div
              className='posRecordWrapper'
              key={index}
              onClick={() => {
                queryRecord(item)
              }}
            >
              <div className='plate'>{item.plate}</div>
              <div>
                {/* 记录 */}
                <div className='info'>
                  <span className='label' style={{ color: '#818599', fontSize: '12px' }}>
                    {!type ? '时间：' : '开始时间：'}
                  </span>
                  <span className='label' style={{ color: '#818599', fontSize: '12px' }}>
                    {!type ? item.queryDate : item.startDate}
                  </span>
                </div>
                <div className='info' style={{ display: 'flex' }}>
                  <span className='label' style={{ color: '#818599', fontSize: '12px' }}>
                    {!type ? '位置：' : '结束时间：'}
                  </span>
                  <span
                    className='label'
                    style={{
                      display: 'flex',
                      flex: 1,
                      flexWrap: 'wrap',
                      color: '#818599',
                      fontSize: '12px',
                    }}
                  >
                    {!type ? item.address : item.endDate}
                  </span>
                </div>
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default QueryRecordCard
